export default __webpack_public_path__ + "static/media/Hack_Banner360.069a9ccc.png";